export default __webpack_public_path__ + "static/char-s-33-ja-856733d6616bbcfff2063261ac37e3e4.webp";